import '../style/cardStyle.css';
import { useSelector } from 'react-redux';
import CardCom from '../components/Card';
import { Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';

export default function AthkarEsabah() {
  const value = useSelector((state) => state.athkarEsabah.value); // Ensure this is the correct slice of state
  const card = useSelector((state) => state.athkarEsabah.data)
 
  return (

    <>
    <Helmet>
        <title>أذكار الصباح</title>
        <meta name='description' content='اذكار الصباح' />
        <link rel="canonical" href="/athkarEsabah" />
    </Helmet>

    <div className='mainScreen'>
      <Progress value={value}/>
       <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary"}}>أذكار الصباح</Typography>
      <CardCom card={card} type={'sabah'}/>
    </div>
    </>
  );
}
